<div class="px-px-24 mt-4 py-px-1" style="background: #F3F8FA;width: calc(100vw - 330px);">
  <div class="header bg-white">
    <div class="p-px-24">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li *ngIf="!!name" class="breadcrumb-item active header fs-24 fw-7 text-primary" aria-current="page">
            Missions de {{name}}
          </li>
        </ol>
      </nav>
    </div>
  </div>
  <div class="missions-container bg-white">
    <mat-tab-group mat-stretch-tabs="{{false}}" mat-align-tabs="start" color="primary">
      <mat-tab label="En cours">
        <app-agency-in-progress-component></app-agency-in-progress-component>
      </mat-tab>
      <mat-tab label="Terminées">
        <app-agency-terminated-mission-for-etab></app-agency-terminated-mission-for-etab>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
<router-outlet></router-outlet>
